var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var CompanyContactsVue_1;
import { Vue, Component, Prop } from "vue-facing-decorator";
import CompanyIndividualContactsVue from "@/app/vues/admin/company-individual-contacts.vue";
import CompanyGroupContactsVue from "@/app/vues/admin/company-group-contacts.vue";
let CompanyContactsVue = CompanyContactsVue_1 = class CompanyContactsVue extends Vue {
    constructor() {
        super(...arguments);
        this.activeTab = 0;
    }
    onContactsUpdated() {
        this.$emit(CompanyContactsVue_1.contactsUpdatedEvent);
    }
};
CompanyContactsVue.contactsUpdatedEvent = "contactsUpdated";
__decorate([
    Prop(),
    __metadata("design:type", Number)
], CompanyContactsVue.prototype, "companyId", void 0);
CompanyContactsVue = CompanyContactsVue_1 = __decorate([
    Component({
        name: "CompanyContactsVue",
        emits: ["contactsUpdated"],
        components: {
            CompanyIndividualContactsVue,
            CompanyGroupContactsVue
        }
    })
], CompanyContactsVue);
export default CompanyContactsVue;
